import type { DiscoveredRouteModule } from '@/router/generator/types';
import { markRaw, defineAsyncComponent } from 'vue';

// Local constants
const ProfileView = () => import('@/views/ProfileView.vue');
const ProfileUserView = () => import('@/views/profile/ProfileUserView.vue');
const ProfilePreferencesView = () => import('@/views/profile/ProfilePreferencesView.vue');
const ProfilePrivacyView = () => import('@/views/profile/ProfilePrivacyView.vue');
const ProfileProjectsView = () => import('@/views/profile/ProfileProjectsView.vue');
const ProfileProjectsManagementView = () => import('@/views/profile/ProfileProjectsManagementView.vue');
const ProfileHeaderComponent = defineAsyncComponent(() => import('@/layouts/ProfileHeader.vue'));

export const NAME_PROFILE = 'Profile';
export const NAME_PROFILE_USER = 'ProfileUser';
export const NAME_PROFILE_PREFERENCES = 'ProfilePreferences';
export const NAME_PROFILE_PRIVACY = 'ProfilePrivacy';
export const NAME_PROFILE_PROJECTS = 'ProfileProjects';
export const NAME_PROJECT_MANAGEMENT = 'ProjectManagement';
export const NAME_PROFILE_INDEX = 'ProfileIndex';
export const PATH_PROFILE = '/profile';

const children = [
  // Default redirect: /profile → /profile/user
  { path: '', name: NAME_PROFILE_INDEX, redirect: { name: NAME_PROFILE_USER } },
  { path: 'user', component: ProfileUserView, name: NAME_PROFILE_USER, meta: { dataLoaders: ['profile_editing'] } },
  { path: 'preferences', component: ProfilePreferencesView, name: NAME_PROFILE_PREFERENCES, meta: { dataLoaders: ['basic_user_context'] } },
  { path: 'privacy', component: ProfilePrivacyView, name: NAME_PROFILE_PRIVACY, meta: { dataLoaders: ['basic_user_context'] } },
  { path: 'projects', component: ProfileProjectsView, name: NAME_PROFILE_PROJECTS, meta: { requiresAuth: true, dataLoaders: ['basic_user_context'] }, children: [
    { path: ':projectId', component: ProfileProjectsManagementView, name: NAME_PROJECT_MANAGEMENT, meta: { dataLoaders: ['basic_user_context'] } },
  ] },
];

export const route: DiscoveredRouteModule = {
  id: 'root.profile',
  scope: 'root',
  name: NAME_PROFILE,
  path: PATH_PROFILE,
  component: ProfileView,
  meta: { requiresAuth: true, dynamicComponent: markRaw(ProfileHeaderComponent), dynamicComponentScale: 'scale-75', dataLoaders: ['basic_user_context'] },
  children,
};
